// react
import React from "react"
import { Link } from "react-router"
// material-ui
import { Card, CardActions, CardHeader, CardText } from "material-ui/Card"
import FlatButton from "material-ui/FlatButton"
import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from "material-ui/Table"
// app
import Avatar from "components/person/Avatar"


const initialState = {
    displayCount: 10,
    selectedRow: false
}


class SearchResult extends React.Component {
    constructor(props) {
        super()

        this.state = initialState

        this.showMore = () => this.setState({
            displayCount: this.state.displayCount + 10 
        })

        this.export = this.export.bind(this)
        this.exportAnonym = this.exportAnonym.bind(this)
        this.handleRowSelection = this.handleRowSelection.bind(this)
        this.isSelected = this.isSelected.bind(this)
    }

    export() {
        if (this.state.selectedRow === false) return

        const ids = []

        for (let i=0; i<this.state.selectedRow.length; i++)
            ids.push(this.props.profiles.get(this.state.selectedRow[i]).get("id"))

        this.props.onExport(ids)
    }

    exportAnonym() {
        if (this.state.selectedRow === false) return

        const ids = []

        for (let i=0; i<this.state.selectedRow.length; i++)
            ids.push(this.props.profiles.get(this.state.selectedRow[i]).get("id"))

        this.props.onAnonymExport(ids)
    }

    handleRowSelection(rows) {
        if (rows.length === 0) this.setState({ selectedRow: false })
        else this.setState({ selectedRow: rows })
    }

    isSelected(rowNumber) {
        if (this.state.selectedRow === false) return false

        for (let i=0; i<this.state.selectedRow.length; i++)
            if (this.state.selectedRow[i] === rowNumber) return true

        return false
    }

    beautify(key, value) {
        if (value === "") return ""

        switch(key) {
            case "rating":
                return "Type Rating = " + value
            case "hours":
                return "Total Flight Hours > " + value
            case "jobstatus":
                return "Job Status = " + value
            case "lookingfor":
                switch(value) {
                    case "freelance":
                        return "Interested in Freelance Contracts"
                    case "permanent":
                        return "Interested in Permanent Contracts"
                    default:
                        return "Currently Not Looking"
                }
            default: 
                return key.substring(0, 1).toUpperCase() + key.substring(1) + " = " + value
        }
    }

    render() {
        const rows = []
        let i = 0

        this.props.profiles.forEach(p => {
            if (i >= this.state.displayCount) return
            rows.push(
                <TableRow
                    key={ p.get("id") }
                    selected={ this.isSelected(i++) }
                >
                    <TableRowColumn>
                        <Link to={ "/profiles/" + p.get("id") } className="underline">
                            { p.get("displayName") }
                        </Link>
                    </TableRowColumn>
                    <TableRowColumn>{ p.get("homebase") }</TableRowColumn>
                    <TableRowColumn>{ p.get("type") }</TableRowColumn>
                    <TableRowColumn>{ p.get("citizenship") }</TableRowColumn>
                    <TableRowColumn style={{ textAlign: "right" }}>
                        <Avatar person={ p } size={ 37 }/>
                    </TableRowColumn>
                </TableRow>
            )
        })

        let niceCriteria = ""
        this.props.criteria.forEach((v, k) => {
            if (v === "") return true
            niceCriteria += (niceCriteria === "" ? "" : ", ") + this.beautify(k, v)
        })

        let title = "Showing 1-"
        title += i
        title += " of "
        title += this.props.count

        return (
            <Card>
                <CardHeader
                    title={ title }
                    style={{ paddingBottom: 0 }}
                />
                <CardText>
                    <small style={{ fontWeight: 300 }}>{ niceCriteria }</small>
                    <Table
                        multiSelectable={ false }
                        onRowSelection={ this.handleRowSelection }>
                        <TableHeader displaySelectAll={ false }>
                            <TableRow>
                                <TableHeaderColumn>Name</TableHeaderColumn>
                                <TableHeaderColumn>Homebase</TableHeaderColumn>
                                <TableHeaderColumn>Profile Type</TableHeaderColumn>
                                <TableHeaderColumn>Citizenship</TableHeaderColumn>
                                <TableHeaderColumn />
                            </TableRow>
                        </TableHeader>
                        <TableBody showRowHover={ true }>
                            { rows }
                        </TableBody>
                    </Table>
                    { this.props.count > rows.length ?
                        <div style={{ marginTop: 24 }}>
                            <FlatButton
                                label="Show more"
                                style={{
                                    color: "#555",
                                    width: "100%"
                                }}
                                onTouchTap={ this.showMore }
                            />
                        </div>
                        : null
                    }
                </CardText>
                <CardActions className="clearfix">
                    <FlatButton
                        primary={ true }
                        label="Export CV"
                        onTouchTap={ this.export }
                        disabled={ this.state.selectedRow === false }
                    />
                    <FlatButton
                        primary={ true }
                        label="Anonymized CV"
                        onTouchTap={ this.exportAnonym }
                        disabled={ this.state.selectedRow === false }
                    />
                    <FlatButton
                        label="new search"
                        style={{ color: "#555" }}
                        onTouchTap={ this.props.onNewSearch }
                    />
                </CardActions>
            </Card>
        )
    }
}

export default SearchResult


/** WEBPACK FOOTER **
 ** ./src/components/search/Result/search-result.js
 **/